import script from "./CvPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CvPage.vue?vue&type=script&setup=true&lang=js"

import "./CvPage.vue?vue&type=style&index=0&id=d87bd190&scoped=true&lang=css"
import "./CvPage.vue?vue&type=style&index=1&id=d87bd190&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d87bd190"]])

export default __exports__